import { Link, useRouterState } from "@tanstack/react-router";
import { AppIcon, IconChevronRight } from "@wilco/ui";
import { useState } from "react";
import { useCan } from "../auth.ts";
import { t } from "../i18n.ts";
import { sectionActive, visibleOperations } from "./operations.ts";
import { visibleSections } from "./sections.ts";
import { TargetLink } from "./targets.tsx";
import "../docs/docs.css";

/**
 * Разделы с иконками: колонка слева на ПК, шторка на телефоне. Текущий
 * пункт на сером с оранжевой полосой, как меню chmk_ui. Под открытым
 * разделом его «Операції» (operations.ts); у остальных разделов они
 * раскрываются стрелкой, без перехода в раздел.
 */
export function SectionNav({ onNavigate }: { onNavigate?: () => void }) {
  const can = useCan();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [opened, setOpened] = useState<string | null>(null);
  return (
    <nav className="nav" aria-label={t("shell.sections")}>
      <ul className="nav-list">
        <li>
          <Link to="/" className="nav-item" activeOptions={{ exact: true }} onClick={onNavigate}>
            <AppIcon name="overview" size={28} />
            <span className="nav-label">{t("section.desk")}</span>
          </Link>
        </li>
        {visibleSections(can).map((s) => {
          const ops = visibleOperations(s.id, can);
          const active = sectionActive(s.id, pathname);
          const open = ops.length > 0 && (active || opened === s.id);
          return (
            <li key={s.id} className="nav-section" data-open={open ? "" : undefined}>
              <div className="nav-row">
                <TargetLink dest={s.target} className="nav-item" data-current={active ? "" : undefined} onClick={onNavigate}>
                  <AppIcon name={s.icon} size={28} />
                  <span className="nav-label">{t(s.label)}</span>
                </TargetLink>
                {ops.length > 0 && !active ? (
                  <button
                    type="button"
                    className="nav-toggle"
                    aria-expanded={open}
                    aria-label={t(open ? "shell.ops.hide" : "shell.ops.show", { section: t(s.label) })}
                    onClick={() => setOpened(open ? null : s.id)}
                  >
                    <IconChevronRight />
                  </button>
                ) : null}
              </div>
              {open ? (
                <ul className="nav-ops" aria-label={t("shell.ops", { section: t(s.label) })}>
                  {ops.map((o) => (
                    <li key={o.id}>
                      <Link to={o.to} className="nav-op" activeOptions={{ exact: true, includeSearch: false }} onClick={onNavigate}>
                        {t(o.label)}
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
